import { Modal } from "@scandotcom/react";
import * as React from "react";

interface ModalProps
  extends Omit<React.ComponentProps<typeof Modal>, "children" | "title"> {}

export function AppointmentInfoModal({ onClose, ...props }: ModalProps) {
  return (
    <Modal
      {...props}
      onClose={onClose}
      className="w-screen sm:max-w-sm"
      transition="up"
    >
      <Modal.Header type="close" onClose={onClose}>
        <h2 className="sm:mr-auto">Appointment requests</h2>
      </Modal.Header>

      <div className="my-4 space-y-2">
        <p>
          Every person is different, and not all scans are the same. That's why
          appointment requests are pending until the following are completed:
        </p>

        <ul className="list-inside list-decimal space-y-2">
          <li>
            <span className="font-semibold">Safety checks</span> by our
            clinicians during your consultation call
          </li>
          <li>
            <span className="font-semibold">Protocolling</span> by the scanning
            site's radiologist(s) to determine the required time, scanner
            settings, and equipment for your appointment.
          </li>
        </ul>
      </div>

      <div className="flex w-full">
        <button type="button" onClick={onClose} className="button button-gray">
          Close
        </button>
      </div>
    </Modal>
  );
}
